import Staff from './root.vue'
import MainNav from './main_nav.vue'
import StaffList from './staff_list/router'
import OperateRecord from './operate_record/router'
import ApplyRecord from './apply_record/router'
import StaffDetail from './staff_detail/router'
import PermissionSet from './permission_set/router'

const route = {
    path: 'staff',
    component: Staff,
    children: [{
        path: '',
        redirect: 'nav'
    }, {
        path: 'nav',
        component: MainNav,
        children: [{
            path: '',
            redirect: StaffList.path
        },
            StaffList,
            OperateRecord,
            ApplyRecord
        ]
    },
        StaffDetail,
        // PermissionSet
    ]
}

export default route
